import React, { FC, useState } from 'react';
import { Icon } from '@/components/atomic/Icon';
import Button from '@/components/Button';
import Timer from '@/components/Timer';
import { classnames } from '@/utils/classnames';

interface IOtpTimer {
  handleRequest: () => void;
  isRequestLoading: boolean;
  isInitialResendEnabled?: boolean;
  countDown?: number;
  label?: string;
  className?: string;
}

const OtpTimer: FC<IOtpTimer> = ({
  handleRequest,
  isRequestLoading,
  isInitialResendEnabled = false,
  countDown = 119,
  label = 'ارسال مجدد',
  className,
}) => {
  const [canResend, setCanResend] = useState(isInitialResendEnabled);

  const handleRequestSubmit = () => {
    handleRequest();
    setCanResend(false);
  };

  return (
    <>
      {canResend ? (
        <Button
          className={classnames('!h-8 text-xs', className)}
          isLoading={isRequestLoading}
          onClick={handleRequestSubmit}
        >
          {label}
        </Button>
      ) : (
        <Button
          className={classnames(
            'flex !h-8 !w-[90px] justify-between',
            className
          )}
          disabled
        >
          <Icon className="ml-2" icon="clock" size={20} />
          <div className="w-10">
            <Timer
              timeout={canResend ? 0 : countDown}
              onEnd={() => setCanResend(true)}
            />
          </div>
        </Button>
      )}
    </>
  );
};

export default OtpTimer;
